// extracted by mini-css-extract-plugin
export default {"column":"Filter_column__HE37T","licensePlateColumn":"Filter_licensePlateColumn__PQo33","similarLicensePlate":"Filter_similarLicensePlate__JKzRo","boxCSV":"Filter_boxCSV__IixRo"};